// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2n-hilUe","overlay":"_2WJ8xbnh","spinner":"_1L-cixt_","sk-stretchdelay":"_3uMZyQmi","rect2":"_9MXR9Psg","rect3":"_1Q3HZGdD","rect4":"_3-dqSZEc","rect5":"_2i0vfqMw"};